export { Providers as default } from '@/screens/home/Providers'
